/* Photo upload slots: show a thumbnail + file name once chosen, reject files
   over the size limit before they reach the cart, and point the shopper at a
   missing required photo when add-to-cart is blocked by form validation. */
(() => {
  if (window.mkPhotoUploadReady) return;
  window.mkPhotoUploadReady = true;

  const showError = (root, message) => {
    const el = root.querySelector('[data-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  };

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches('.mk-upload__input')) return;
    const root = input.closest('[data-mk-upload]');
    const slot = input.closest('.mk-upload__slot');
    const status = slot.querySelector('[data-status]');
    const thumb = slot.querySelector('.mk-upload__thumb');
    const file = input.files && input.files[0];
    const maxMb = Number(root.dataset.maxMb || 20);
    slot.classList.remove('is-invalid');
    showError(root, '');
    // Start from the camera icon so a cancelled/rejected/HEIC pick never shows a stale preview.
    if (!thumb.dataset.icon) thumb.dataset.icon = thumb.innerHTML;
    thumb.innerHTML = thumb.dataset.icon;

    if (!file) {
      slot.classList.remove('is-filled');
      status.textContent = 'Tap to upload';
      return;
    }
    if (file.size > maxMb * 1024 * 1024) {
      input.value = '';
      slot.classList.remove('is-filled');
      slot.classList.add('is-invalid');
      status.textContent = 'Tap to upload';
      showError(root, `That photo is over ${maxMb} MB. Please choose a smaller one.`);
      return;
    }
    slot.classList.add('is-filled');
    status.textContent = file.name;
    // HEIC cannot be previewed by most browsers; keep the camera icon for those.
    if (/^image\/(jpeg|png|webp|gif)$/.test(file.type)) {
      const img = document.createElement('img');
      img.alt = '';
      img.src = URL.createObjectURL(file);
      img.onload = () => URL.revokeObjectURL(img.src);
      thumb.replaceChildren(img);
    }
  });

  // The browser's own bubble is easy to miss on a file input; add a visible message too.
  document.addEventListener('invalid', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches('.mk-upload__input')) return;
    const root = input.closest('[data-mk-upload]');
    input.closest('.mk-upload__slot').classList.add('is-invalid');
    showError(root, 'Please upload a photo so we can make your doll.');
  }, true);
})();
